/* Built In Imports */
import NextLink from 'next/link';

/* External Imports */
import { Box, Link } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import { Flex } from '@chakra-ui/react';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import { refineUrlDomain } from '@components/Utility/utils';
import SectionTitle from '@eternal/Components/Headings/SectionTitle';
import MidContainer from '@eternal/Components/Layout/MidContainer';
import { nanoid } from 'nanoid';
import React from 'react';
import { useMediaQuery } from 'react-responsive';

/**
 * 
 * @param {Object} sectionContent 
 * @returns 
 */
const AdBanners = ({ sectionContent, region, lang }) => {
  const findElement = param =>
    sectionContent.find(el => el._modelApiKey === param);
  const isMobile = useMediaQuery({ maxWidth: 767 });
  return (
    <MidContainer w="1200px" my="30px" py="0">
      <Box>
        <SectionTitle titleObj={findElement('section_title')} />
      </Box>
      <Flex
        flexWrap="wrap"
        w="100%"
        alignItems="center"
        justifyContent={{ base: 'center', md: 'center' }}
        gap="17px"
      >
        {sectionContent[0].cards.map(el => (
          <Box
            key={nanoid()}
            maxW={{ base: '280px', md: 'none' }}
            minW={225}
            flex={1}
            my="10px"
            w={{ base: '100%', md: 380 }}
          >
            {/* <ImageBanner
                w="100%"
                flex="1"
                my="10px"
                minW="280px"
                sectionContent={el}
                region={region}
                lang={lang}
              /> */}
            <NextLink
              href={
                el?.buttonLink
                  ? refineUrlDomain(el?.buttonLink, '', '')
                  : 'javascript:;'
              }
              passHref
              legacyBehavior
            >
              <Link
                w="100%"
                display="block"
                target="_blank"
              >
                <LazyLoadImageComponent
                  alt={el?.image?.title}
                  title={el?.image?.title}
                  textAlign="center"
                  src={el?.mobileImage?.url}
                  _hover={{
                    content: `url(${el?.thumbnail?.url})`,
                  }}
                  w="100%"
                  objectFit="cover"
                />
              </Link>
            </NextLink>
          </Box>
        ))}
      </Flex>
    </MidContainer>
  );
};

export default AdBanners;
